module.exports = __webpack_public_path__ + "img/logo_rovinieta.b2301587.svg";